export const CURIOSITIES_TEST_MODE = false;

export const PERSON_HEIGHT_M = 1.7;
export const PERSON_SIDE_BY_SIDE_M = 1.7;
export const PERSON_IN_LINE_M = 0.5;
